import { SectionHeader } from "@/components/Common/SectionHeader/SectionHeader";

export const SettingsSectionCard: React.FC<{
  title: string;
  description: string;
  children: React.ReactNode;
  savedInConfig?: boolean;
}> = ({ title, description, children, savedInConfig = false }) => (
  <div className="flex w-full flex-col gap-6">
    <SectionHeader title={title} subtitle={description} savedInConfig={savedInConfig} />
    {children}
  </div>
);
